import './MyMahiComplete.scss'
import React from "react";
import {ThemedLottiePlayerComponent} from "../../components/common/lottie-player/ThemedLottiePlayerComponent";
import {isMobileDevice} from "../../utils/WindowUtils";

export const MyMahiCompletePage: React.FC = () => {
    return (
        <div className={`background-complete general-container mymahi-complete-container height-window 
        ${isMobileDevice() ? 'tertiary-blue-background' : ''}`}>
            <div className={`flex-center mymahi-complete-lottie-container`}>
                <ThemedLottiePlayerComponent animation="success"/>
            </div>
            <div className={`flex-center mymahi-complete-text-container`}>
                <span className={`font-white general-title general-result-title mymahi-complete-title-font`}>
                    All done!
                </span>
                <span className={`flex-center font-white general-subtitle mymahi-complete-title-text`}>
                    Your MyMahi Digital Learner ID is verified.
                </span>
                <span className={`flex-center font-white general-subtitle mymahi-complete-title-text`}>
                    You can now return to the Emerge app.
                </span>
            </div>
        </div>
    )
}